export class Pdf64Helpers {
    public static getBlobUrl(pdf64: string): string {
        let byteString = atob(pdf64);
        let byteNumbers = new Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteNumbers[i] = byteString.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], {type: 'application/pdf'});
        return URL.createObjectURL(blob, {}); // filename
    }

    public static msSaveOrOpenBlob(pdf64: string, fileName?: string) {
        let byteString = atob(pdf64);
        let byteNumbers = new Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            byteNumbers[i] = byteString.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], {type: 'application/pdf'});

        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }

    public static getDataUrl(pdf64: string): string {
        return 'data:application/pdf;base64,' + pdf64;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Common/pdf.helpers.ts
 **/